// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_modalBackdrop__y-3up {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.styles_modalContainer__vYF6I {
  background-color: white;
  border-radius: 20px;
  max-width: 520px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.styles_modalContent__cImOR {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
}

.styles_modalIcon__b-s96 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.styles_modalIcon__b-s96.styles_error__s3joi {
  background-color: #EF4444;
  color: white;
}
.styles_modalIcon__b-s96.styles_info__LxNjl {
  background-color: #3B82F6;
  color: white;
}

.styles_modalText__fj27I {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.styles_modalTitle__ue9KH {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: var(--color-text-primary);
  margin: 0;
}

.styles_modalMessage__ziZJs {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--color-text-secondary);
  margin: 0;
}

.styles_modalActions__QpXVs {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
  margin-top: 32px;
  flex-direction: column;
}
@media (min-width: 768px) {
  .styles_modalActions__QpXVs {
    flex-direction: row;
  }
}

.styles_modalPrimaryButton__KVutE {
  width: 100%;
  justify-content: center;
}
@media (min-width: 640px) {
  .styles_modalPrimaryButton__KVutE {
    order: 2;
  }
}

.styles_modalSecondaryButton__N9nuL {
  width: 100%;
  justify-content: center;
}
@media (min-width: 640px) {
  .styles_modalSecondaryButton__N9nuL {
    order: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modal/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAAF;;AAGA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAF;AAEE;EACE,yBAAA;EACA,YAAA;AAAJ;AAGE;EACE,yBAAA;EACA,YAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,SAAA;AAFF;;AAKA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;AAFF;AC3EE;EDuEF;IASI,mBAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,uBAAA;AADF;AC3FE;ED0FF;IAKI,QAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,uBAAA;AAAF;ACrGE;EDmGF;IAKI,QAAA;EACF;AACF","sourcesContent":["@import \"mixins\";\n.modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modalContainer {\n  background-color: white;\n  border-radius: 20px;\n  max-width: 520px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 24px;\n}\n\n.modalIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  &.error {\n    background-color: #EF4444;\n    color: white;\n  }\n\n  &.info {\n    background-color: #3B82F6;\n    color: white;\n  }\n}\n\n.modalText {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.modalTitle {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.modalMessage {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.modalActions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  justify-content: space-between;\n  margin-top: 32px;\n  flex-direction: column;\n\n  @include md {\n    flex-direction: row;\n  }\n}\n\n.modalPrimaryButton {\n  width: 100%;\n  justify-content: center;\n\n  @include sm {\n    order: 2;\n  }\n}\n\n.modalSecondaryButton {\n  width: 100%;\n  justify-content: center;\n\n  @include sm {\n    order: 1;\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `styles_modalBackdrop__y-3up`,
	"modalContainer": `styles_modalContainer__vYF6I`,
	"modalContent": `styles_modalContent__cImOR`,
	"modalIcon": `styles_modalIcon__b-s96`,
	"error": `styles_error__s3joi`,
	"info": `styles_info__LxNjl`,
	"modalText": `styles_modalText__fj27I`,
	"modalTitle": `styles_modalTitle__ue9KH`,
	"modalMessage": `styles_modalMessage__ziZJs`,
	"modalActions": `styles_modalActions__QpXVs`,
	"modalPrimaryButton": `styles_modalPrimaryButton__KVutE`,
	"modalSecondaryButton": `styles_modalSecondaryButton__N9nuL`
};
export default ___CSS_LOADER_EXPORT___;
